import { SearchInput } from "@/components/atoms/search";
import { ReactNode } from "react";

interface TableToolbarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  isLoading?: boolean;
  actions?: ReactNode;
}

export function TableToolbar({
  searchValue,
  onSearchChange,
  searchPlaceholder = "Buscar...",
  isLoading = false,
  actions,
}: TableToolbarProps) {
  return (
    <div className="flex items-center justify-between gap-4 p-4">
      <SearchInput
        value={searchValue}
        onChange={onSearchChange}
        placeholder={searchPlaceholder}
        disabled={isLoading}
        className="max-w-2xl flex-1"
      />
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
